<template>
    <div class="app-wrapper">
        <!-- 进场页（独立白色宣传页，桌面/移动通用） -->
        <transition name="intro-page">
            <div v-if="intro" class="intro-screen">
                <span class="intro-screen__text">精准智控，<span class="km-gradient-text">慧创未来</span></span>
            </div>
        </transition>

        <component :is="viewType" />
    </div>
</template>

<script>
import { isMobileDevice } from '../utils/public';
import DesktopView from "./DesktopView.vue"; //功能页面
import MoblieView from "./MoblieView.vue"; //功能页面

export default {
    name: "MainIndex",
    //建立父子联系
    components: { DesktopView, MoblieView },
    data() {
        return {
            viewType: "DesktopView",
            intro: true
        };
    },
    mounted() {
        let userAgentInfo = navigator.userAgent;
        let isMobile = userAgentInfo.indexOf("Windows") < 0;
        console.log(isMobile);
        let dd = this;
        if (isMobileDevice()) {
            dd.viewType = "MoblieView";
        }
        this._introTimer = setTimeout(() => {
            this.intro = false;
        }, 3300);
    },
    beforeUnmount() {
        if (this._introTimer) clearTimeout(this._introTimer);
    },
    methods: {
        test() {
        }
    } /*,
    mixins: [ResizeHandle]*/
};
</script>

<style scoped>
.app-wrapper {
    width: 100%;
}

/* ---- 进场页（独立白色页面 + 口号淡入淡出） ---- */
.intro-screen {
    position: fixed;
    inset: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 24px;
    background: #ffffff;
}

.intro-screen__text {
    font-family: var(--font-display);
    font-weight: 800;
    font-size: clamp(32px, 9vw, 110px);
    letter-spacing: -0.03em;
    line-height: 1.1;
    color: var(--text);
    /* 慢速淡入 -> 短暂停顿 -> 慢速淡出 */
    animation: intro-text 3.3s ease both;
}

@keyframes intro-text {
    0% {
        opacity: 0;
    }

    48% {
        opacity: 1;
    }

    /* 完全显示后约 0.5s 停顿 */
    64% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

/* Vue transition：白色页面转场至主页 */
.intro-page-leave-active {
    transition: opacity 0.9s ease, transform 0.9s cubic-bezier(0.65, 0, 0.35, 1);
}

.intro-page-leave-to {
    opacity: 0;
    transform: translateY(-8%) scale(1.03);
}

@media (prefers-reduced-motion: reduce) {
    .intro-screen__text {
        animation: none !important;
        opacity: 1;
    }
}
</style>
